<template>
    <div class="row">
        <div class="col-md-3 col-sm-12 cus-sidebar">
            <Sidebar  />
        </div>
        <div v-if="isLoading" class="loader">
            <div class="wave-container">
                <div class="wave"></div>
                <div class="wave"></div>
                <div class="wave"></div>
                <div class="wave"></div>
                <div class="wave"></div>
            </div>
            <p>Loading...</p>
        </div>
        <div v-if="!isLoading" class="col-md-9 col-sm-12 right-colm">
            <div class="right-content">
                <div class="row content-row">
                    <ModuleBox v-for="(ModuleData,index) in allModules" :key="index" :ModuleData="ModuleData"  />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Sidebar from './components/Sidebar.vue';
import userAPI from '../userApi';
import ModuleBox from './components/ModuleBox.vue';

export default {
    name: "Modules",
    data() {
        return {
            isLoading:false,
            allModules: []
        }
    },
    methods: {
        getAllModules() {
            this.isLoading = true;
            userAPI.getAllModules(res => {
                this.allModules = res.data.data;
                this.isLoading = false;
            }, err => {
                console.log(err);
                this.isLoading = false;
            })
        }
    },
    mounted() {
        this.getAllModules()
    },
    components: {
        ModuleBox,
        Sidebar
    }
}
</script>